import { setPassword } from '../../../data/repositories/authRepository.js';

export const updatePassword = (password) => setPassword(password);
